export const CLEAR_PAGE_CACHE_EVENT = 'corrguard:clear-page-cache';

export const clearPageCache = () => {
	if (typeof window === 'undefined' || typeof window.dispatchEvent !== 'function') {
		return;
	}
	window.dispatchEvent(new window.Event(CLEAR_PAGE_CACHE_EVENT));
};

export const addClearPageCacheListener = listener => {
	if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
		return () => {};
	}
	window.addEventListener(CLEAR_PAGE_CACHE_EVENT, listener);
	return () => window.removeEventListener(CLEAR_PAGE_CACHE_EVENT, listener);
};
